import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutWirecodeLookup extends Layout {
    sourceWirecode: DataSource;
    table_: Table;
}
